var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1979 5.01988C9.30032 4.30334 9.43505 3.50164 9.71611 3.18212C10.6738 2.09342 9.94787 1.4554 9.47271 1.19024C8.54027 0.752043 6.38804 0.152565 4.66413 0.753518C2.50925 1.50471 1.39295 3.06653 0.855631 4.37599C0.290321 5.75366 0.0815888 8.98707 2.72401 11.3804C4.2468 12.7596 5.82602 13.5 7.92409 13.5C10.2007 13.5 12.5605 12.6942 13.3566 9.9831C14.1846 7.16355 11.1997 5.8196 10.1979 5.01988Z",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.07819,
    cy: 4.0904,
    r: 1.78132,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.58724,
    cy: 8.03939,
    r: 1.16537,
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.69662,
    cy: 10.37,
    r: 1.16537,
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2747,
    cy: 9.20492,
    r: 1.16537,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialColor);
export default __webpack_public_path__ + "static/media/materialColor.0779bda76c9059dde24884c80dd3af4f.svg";
export { ForwardRef as ReactComponent };